import { get } from '../../utility/apiClient';
import { errorTypesEnum } from '../../utility/enums';
import { showMessageBox, resetMessageBox } from './messageBoxActions';
import { showLoadingScreen, hideLoadingScreen } from './loadingScreenActions';

//Action creator with API call (Author : Rukshan - 2020-07-05)
export function fetchTrackingDetail(requestParams) {
    return dispatch => {
        dispatch(showLoadingScreen());
        dispatch({ type: 'FETCHING_TRACKING_DETAIL' });
        return new Promise(function (resolve, reject) {
            get(`/OrderTracking/GetOrderTrackingDetails?authorizationField=${requestParams.authorizationField}&orderNo=${requestParams.orderNumber}`)
                .then(response => {
                    if (response.data.statusCode === 200) {
                        dispatch(addTrackingDetail(response.data.result)).then(() => {
                            resolve(true);
                        });
                    } else {
                        let errorType = response.data.errorList[0].errorType;
                        let messageBox = {
                            show: true,
                            title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                            className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                            content: response.data.errorList[0].statusMessage,
                            isConfirmation: false,
                            callBackFunction: () => { dispatch(resetMessageBox(messageBox)); window.location.replace("/welcome/TrackOrder"); }
                        }
                        dispatch(showMessageBox(messageBox));
                        reject(response.data.errorList[0].statusMessage)
                    }
                    dispatch(hideLoadingScreen());
                })
        });
    }
};

export function addTrackingDetail(orderTrackingDetails) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_TRACKING_DETAIL',
                payload: orderTrackingDetails
            });
            resolve(true)
        });
    }
};

export const resetTrackingDetail = () => ({
    type: 'RESET_TRACKING_DETAIL'
});